module.exports = __webpack_public_path__ + "img/talent_tit.2d9c8763.jpg";